module.exports = __webpack_public_path__ + "static/media/XML.4ea9a1f0.svg";